// extracted by mini-css-extract-plugin
export default {"outerContainer":"AspectRatioView_outerContainer__bi9nt","innerContainer":"AspectRatioView_innerContainer__dvZ7w"};